// Shim for scheduler APIs that were removed in React 18's scheduler package.
// Some older libraries (formik v2) still reference these.
import * as scheduler from 'scheduler-raw';

export const {
    unstable_ImmediatePriority,
    unstable_UserBlockingPriority,
    unstable_NormalPriority,
    unstable_IdlePriority,
    unstable_LowPriority,
    unstable_scheduleCallback,
    unstable_cancelCallback,
    unstable_shouldYield,
    unstable_requestPaint,
    unstable_now,
    unstable_getCurrentPriorityLevel,
} = scheduler;

export const unstable_runWithPriority = scheduler.unstable_runWithPriority || ((_priority, fn) => fn());
export const unstable_next = scheduler.unstable_next || ((fn) => fn());
export const unstable_wrapCallback = scheduler.unstable_wrapCallback || ((fn) => fn);
export const unstable_pauseExecution = scheduler.unstable_pauseExecution || (() => {});
export const unstable_continueExecution = scheduler.unstable_continueExecution || (() => {});
export const unstable_forceFrameRate = scheduler.unstable_forceFrameRate || (() => {});
export const unstable_getFirstCallbackNode = scheduler.unstable_getFirstCallbackNode || (() => null);
export const unstable_Profiling = scheduler.unstable_Profiling || null;
